"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Tabs_1 = require("@mui/material/Tabs");
const Tab_1 = require("@mui/material/Tab");
const Box_1 = require("@mui/material/Box");
const react_1 = require("react");
const merge_1 = require("merge");
const material_1 = require("@mui/material");
const index_styles_1 = require("./index.styles");
function ContentPanel(_a) {
    var { children, index, value, classes } = _a, props = __rest(_a, ["children", "index", "value", "classes"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ hidden: value !== index, id: `content-switcher-panel-${index}`, "aria-labelledby": `content-switcher-${index}` }, props, { children: value === index && ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: (0, merge_1.merge)(true, classes === null || classes === void 0 ? void 0 : classes.childrenOverrides), children: (0, jsx_runtime_1.jsx)(Box_1.default, { sx: { fontFamily: 'inherit' }, children: children }) })) })));
}
const ContentSwitcher = (_a) => {
    var { items, classes, initialValue, sticky } = _a, props = __rest(_a, ["items", "classes", "initialValue", "sticky"]);
    const [value, setValue] = (0, react_1.useState)(0);
    const theme = (0, material_1.useTheme)();
    const { boxStyles, tabStyles, tabTextStyles, containerBoxStyles, stickyStyles } = (0, index_styles_1.default)();
    (0, react_1.useEffect)(() => {
        if (initialValue === 0) {
            setValue(initialValue);
        }
    }, [initialValue]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: (0, merge_1.merge)(true, containerBoxStyles, classes === null || classes === void 0 ? void 0 : classes.containerBoxOverrides), children: [(0, jsx_runtime_1.jsx)(Box_1.default, { sx: (0, merge_1.merge)(true, boxStyles, classes === null || classes === void 0 ? void 0 : classes.boxOverrides, sticky ? stickyStyles : null), children: (0, jsx_runtime_1.jsx)(Tabs_1.default, Object.assign({ variant: "scrollable", scrollButtons: false, TabIndicatorProps: {
                        sx: () => ({
                            background: theme.qlub.palette.iris.main,
                            height: '2px',
                        }),
                    }, sx: classes === null || classes === void 0 ? void 0 : classes.tabsOverrides, value: value, onChange: handleChange, "aria-label": "content switcher" }, props, { children: items.map((item, i) => {
                        return ((0, jsx_runtime_1.jsx)(Tab_1.default, { disabled: item.disabled, sx: (0, merge_1.merge)(true, tabTextStyles, tabStyles, classes === null || classes === void 0 ? void 0 : classes.tabOverrides), label: item.label }, i));
                    }) })) }), items.map((item) => {
                return ((0, jsx_runtime_1.jsx)(ContentPanel, { value: value, index: item.index, children: item.children && item.children }, item.index));
            })] }));
};
exports.default = ContentSwitcher;
